"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParams = void 0;
const qs_1 = __importDefault(require("qs"));
const react_router_dom_1 = require("react-router-dom");
/**
 * @author Renan Salustiano <renan.salustano@ter.grupomarista.org.br>
 * @param props
 */
const useSearchParams = (props = { preserveState: true }) => {
    const { preserveState } = props;
    const { search, pathname } = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const searchParams = new URLSearchParams(search);
    const changeHistory = (params) => {
        if (preserveState)
            history.push({ search: params.toString() });
        history.replace({ search: params.toString(), state: null });
    };
    const setSearchParam = (key, value) => {
        searchParams.set(key, value);
        changeHistory(searchParams);
    };
    const removeSearchParam = (key) => {
        searchParams.delete(key);
        changeHistory(searchParams);
    };
    const getSearchParam = (key) => {
        var _a;
        return (_a = searchParams.get(key)) !== null && _a !== void 0 ? _a : '';
    };
    const getAllSearchParams = () => {
        return qs_1.default.parse(searchParams.toString());
    };
    const clearSearchParams = (paramsToMantain) => {
        changeHistory(paramsToMantain || new URLSearchParams());
    };
    const goBack = () => {
        history.goBack();
    };
    return {
        setSearchParam,
        removeSearchParam,
        getSearchParam,
        getAllSearchParams,
        goBack,
        clearSearchParams,
        history,
    };
};
exports.useSearchParams = useSearchParams;
